import React, { useCallback, useMemo, useState } from 'react';
import { Field } from 'formik';

import { useClickOutside } from '../../../hooks/useClickOutside';

import ButtonSelect from './ButtonSelect';

import { ReactComponent as DownArrow } from './../downArrow.svg';
import { ReactComponent as ChosenOption } from './chosenOption.svg';
import classNames from 'classnames';

const FormSelectField = ({ name, header, list, values, setValues, touched, errors }) => {
    const [selectIsOpen, setSelectIsOpen] = useState(false);

    let domNode = useClickOutside(() => {
        setSelectIsOpen(false);
    });

    const renderDropDownList = list => {
        return list.map(item => {
            const isChosen = item === values[name];
            const dropDownListItemClass = classNames({
                dropDown__listItem: true,
                chosenOption: isChosen,
            });
            const handleChosen = () => {
                setValue(item);
                setSelectIsOpen(false);
            };
            return (
                <li key={item} className={dropDownListItemClass} onClick={handleChosen}>
                    <span className="dropDown__listItem-value">{item}</span>
                    {isChosen && <ChosenOption />}
                </li>
            );
        });
    };

    const dropDownItems = useMemo(() => renderDropDownList(list), [list, values[name]]);

    const handleToggle = useCallback(() => {
        setSelectIsOpen(!selectIsOpen);
    }, [selectIsOpen]);

    const setValue = value => {
        setValues(prevValues => ({
            ...prevValues,
            [name]: value,
        }));
    };

    const dropDownHeaderClass = classNames({
        dropDown__header: true,
        'field-error': errors[name] && touched[name] && !selectIsOpen,
    });

    const dropDownListContainerClass = classNames({
        dropDown__listContainer: true,
        [`dropDown__listContainer_${name}`]: true,
    });

    return (
        <div className="dropDownContainer" ref={domNode}>
            <div className={dropDownHeaderClass} onClick={handleToggle}>
                <Field as={ButtonSelect} name={name} header={header} values={values} />
                <DownArrow />
            </div>
            {selectIsOpen && (
                <div className={dropDownListContainerClass}>
                    <ul className="dropDown__list">{dropDownItems}</ul>
                </div>
            )}
        </div>
    );
};

export default FormSelectField;
